import { useEffect, useRef } from "react";

/** Keep a staged submission's identity through a lost response and manual retry. */
export function useIntentKey(scope?: string) {
  const intent = useRef<{ signature: string; key: string } | null>(null);
  useEffect(() => {
    intent.current = null;
    return () => {
      intent.current = null;
    };
  }, [scope]);
  const keyFor = (payload: unknown) => {
    const signature = JSON.stringify(payload);
    if (intent.current?.signature !== signature)
      intent.current = { signature, key: crypto.randomUUID() };
    return intent.current.key;
  };
  keyFor.accept = (key: string) => {
    if (intent.current?.key === key) intent.current = null;
  };
  keyFor.isCurrent = (key: string) => intent.current?.key === key;
  return keyFor;
}
